import { IconProps } from "../../components/Input/types";

const LeadCommentIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 18"
      className={className ? className : "w-[18px] h-[18px]"}
      {...rest}
    >
      <g clipPath="url(#clip0_9989_109924)">
        <path
          fill="currentColor"
          d="M11.8 2H6.2a4.204 4.204 0 0 0-4.199 4.199v3.266a4.204 4.204 0 0 0 3.966 4.192v1.947a.397.397 0 0 0 .676.28l.438-.438a6.05 6.05 0 0 1 4.302-1.782h.416a4.204 4.204 0 0 0 4.199-4.2V6.2A4.204 4.204 0 0 0 11.799 2M5.968 8.765a.934.934 0 0 1 0-1.866.934.934 0 0 1 0 1.866m3.033 0a.934.934 0 0 1 0-1.866.934.934 0 0 1 0 1.866m3.032 0a.934.934 0 0 1 0-1.866.934.934 0 0 1 0 1.866"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_9989_109924">
          <path fill="#fff" d="M2 2h14v14H2z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export default LeadCommentIcon;
